export function getAndroidVersion(ua: string) {
  const match = ua.toLowerCase().match(/android\s([0-9\.]*)/i);
  return match ? match[1] : undefined;
}
